import React, { lazy } from 'react';
import Tool from '../../shared/components/Tool';
import {
	MUTATION_DELETE_MPB_CASE,
	MUTATION_UPDATE_MPB_CASE,
} from '../../shared/gql/mutations';
import {
	QUERY_GET_ALL_MPB_CASES,
	QUERY_GET_MPB_CASE,
} from '../../shared/gql/queries';
import CaseProvider from '../../shared/providers/CaseProvider';

const MietpreisbremseCase = lazy(() => import('./MietpreisbremseCase'));
const Mietpreisbremse = () => (
	<CaseProvider caseMutation={MUTATION_UPDATE_MPB_CASE}>
		<Tool
			caseQuery={QUERY_GET_MPB_CASE}
			allCasesQuery={QUERY_GET_ALL_MPB_CASES}
			deleteMutation={MUTATION_DELETE_MPB_CASE}
			partitionKey='C'
		>
			<MietpreisbremseCase />
		</Tool>
	</CaseProvider>
);

export default Mietpreisbremse;
